import React, { useState } from "react";
import SourceFlowForm from "@sourceflow-uk/sourceflowform";
import SourceFlowApplicationForm from "@sourceflow-uk/sourceflowapplicationform";
import { Helmet } from "react-helmet";
import classes from "./styles.module.scss";
import clsx from "classnames";

export default function Form({ className, formId = null, jobId = null, onSubmitDone = () => {} }) {
  const [showModal, setShowModal] = useState(false);

  if (formId === null && jobId == null) {
    return null;
  }

  const handleSubmitDone = () => {
    setShowModal(true);
    onSubmitDone();
  };

  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/choices.js/public/assets/styles/choices.min.css"
          crossOrigin="anonymous"
          referrerPolicy="no-referrer"
        />
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css"
          integrity="sha512-z3gLpd7yknf1YoNbCzqRKc4qyor8gaKU1qmn+CShxbuBusANI9QpRohGBreCFkKxLhei6S9CQXFEbbKuqLg0DA=="
          crossOrigin="anonymous"
          referrerPolicy="no-referrer"
        />
      </Helmet>

      <div className={clsx(className, classes.form)}>
        {jobId ? (
          <SourceFlowApplicationForm jobId={jobId} onSubmitDone={handleSubmitDone} />
        ) : (
          <SourceFlowForm formId={formId} onSubmitDone={handleSubmitDone} />
        )}
      </div>

      {showModal && (
        <div className={clsx(classes.overlayStyles)} onClick={() => setShowModal(false)}>
          <div className={clsx(classes.modalStyles)} onClick={(e) => e.stopPropagation()}>
            <h2>Success</h2>
            <p>
              {jobId
                ? "Your job application has been submitted successfully!"
                : "Your form has been submitted successfully!"}
            </p>
            <button className={clsx(classes.buttonStyles)} onClick={() => setShowModal(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
}
